import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom';
import api from '../contexts/BaseUrl';
import './Login.css';
import { FaEyeSlash, FaEye } from "react-icons/fa";
import {Spinner} from 'react-activity'
import "react-activity/dist/Spinner.css";

export default function Login(){

    const navigate = useNavigate();

    //login field params
    const [eyeOn, setEyeOn] = useState(false);
    const [passwordtype, setPasswordtype] = useState('password');
    
    //login form params
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleEyeOnClick = () => {
        setEyeOn(true);
        setPasswordtype('text');
    }

    const handleEyeOffClick = () => {
        setEyeOn(false);
        setPasswordtype('password');
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        await api.post(`accounts/login`, {
            email: email,
            password: password
        },{
            headers:{"Content-Type" : "application/json"}
        }).then(response => {
            localStorage.setItem('auth', JSON.stringify(response.data));
            setEmail('');
            setPassword('');
            setIsError(false);
            setErrorMsg('')
            setIsLoading(false);
            navigate('/')
        }).catch(err => {
            const code = err.response.status;

            if(code === 401){
                setErrorMsg("Invalid email or password!");
            }else{
                setErrorMsg("Login failed! Please try again later.")
            }
            setEmail('');
            setPassword('');
            setIsLoading(false);
            setIsError(true);
        })
    }

    return(
        <div className='login'>
            <div id='loginModal'>
                <div id='header'>Porichorja <span id='headerRed'>Crop</span> </div>
               
                <form id='loginBox' onSubmit={handleLogin}>
                    {isError && 
                      <div id='errorMsg'>{errorMsg}</div>
                    }
                  
                    <div id='emailHeader'>Email:</div>
                    <input
                        id='inputBox'
                        type='email'
                        required
                        placeholder='Type your email...'
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />

                    <div id='emailHeader'>Password:</div>
                    <div id='passwordBox'>
                        <input
                            id='inputBoxPassword'
                            type={passwordtype}
                            required
                            placeholder='Type your password...'
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                        {!eyeOn ?
                            <FaEyeSlash 
                                id='eye' 
                                onClick={handleEyeOnClick} 
                            /> 
                                : 
                            <FaEye  
                                id='eye' 
                                onClick={handleEyeOffClick}
                            />  
                        }
                        
                    </div>
                    {
                        !isLoading ?
                        <button id='loginButton'>Login</button> :
                        <button id='loginButton'><Spinner size={10} color = "black" style={{display:"block", margin:'auto'}} /></button>
                    }

                    
                    <div id='forgotPassword' onClick={() => navigate('/forgot-password')}>Forgot password?</div>
                    
                </form>
            </div>
        </div>
    )
}